module.exports = {"id":"187652","name":"David Yurchenko","rating":"73","photo":"./data/images/photos/0/187652.png","club":{"name":"FC Tosno","logo":"./data/images/clubs/FCTosno.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavidYurchenko0.json
// module id = 1010
// module chunks = 0